// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 48 ? "01e5311c" : chunkId) + "." + {"48":"6be0d2bb567a201c","816":"9d36b9f851c8696e","968":"7f6a38a03bba598b"}[chunkId] + ".js";
};